import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  langName: string = 'H-Language';

  private languageSubject = new BehaviorSubject<string>(
    localStorage.getItem(this.langName) || 'en-GB'
  );
  language$ = this.languageSubject.asObservable();

  constructor(private translate: TranslateService) {}

  useDefaultLang() {
    this.translate.setDefaultLang('En');
  }

  usePresentLang(lang: string) {
    this.translate.use(lang);
    this.languageSubject.next(lang);
  }
}
